/**
 * collection-page-premium.js
 * Filter drawer open/close, and auto-submit the native Shopify filter form
 * when a checkbox or the sort dropdown changes (still works without JS —
 * the form has a real submit button as a fallback).
 */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cp-filter-drawer]');
  var toggleBtn = document.querySelector('[data-cp-filter-toggle]');
  var closeBtn = document.querySelector('[data-cp-filter-close]');
  var overlay = document.querySelector('[data-cp-filter-overlay]');
  var form = document.getElementById('CpFilterForm');
  var sortSelect = document.querySelector('[data-cp-sort]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    void drawer.offsetHeight;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Auto-submit filters on checkbox change for a smoother UX.
  if (form) {
    form.addEventListener('change', function (event) {
      if (event.target.matches('input[type="checkbox"]')) {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });
  }

  // Sort dropdown submits the same form (it's linked via the `form`
  // attribute in the HTML), reloading with the new sort_by param.
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var targetForm = document.getElementById(sortSelect.getAttribute('form')) || form;
      if (targetForm) {
        targetForm.requestSubmit ? targetForm.requestSubmit() : targetForm.submit();
      } else {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      }
    });
  }

})();
